import utils from '../utils'
import categorys from '../utils/categorys.js'
export default {
    state: {
        categorys: categorys
    },
    getters: {
        categorys(state) {
            return state.categorys;
        }
    },
    mutations: {},
    actions: {}
}



// WEBPACK FOOTER //
// ./src/store/categoryStore.js